import LeadForm from "@/components/feature/LeadForm";

const TRUST_ITEMS = ["No credit card", "Live in 5 minutes", "Cancel anytime"];

export default function GetStarted() {
  return (
    <section
      id="get-started"
      className="relative bg-background-100 py-20 md:py-24 px-4 md:px-8 border-y border-background-300/20 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 -right-20 w-[460px] h-[460px] rounded-full joble-glow-accent"></div>
      </div>

      <div className="relative max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="reveal text-center lg:text-left">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-foreground-950 leading-tight tracking-tight">
            Prefer a human? Get started in 5 minutes
          </h2>
          <p className="mt-5 text-base text-foreground-700 leading-relaxed max-w-lg mx-auto lg:mx-0">
            Want to skip the demo and just talk to someone? Drop your email and tell us what you
            need help with. A Joble specialist will reach out and get you live, no credit card, no
            developer, no risk.
          </p>

          <div className="mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-x-4 gap-y-2">
            {TRUST_ITEMS.map((item, index) => (
              <div key={item} className="flex items-center gap-4">
                {index > 0 && (
                  <span className="hidden sm:block w-1 h-1 rounded-full bg-foreground-500"></span>
                )}
                <span className="text-xs md:text-sm font-medium text-foreground-700 tracking-wide whitespace-nowrap">
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto">
          <LeadForm />
        </div>
      </div>
    </section>
  );
}